import React, { useEffect, useRef } from "react";
import { observer } from "mobx-react";
import { useFixBody } from "@state/hooks/shared";
import BettingTipsPopupHeader from "./components/popups/BettingTipsPopupHeader";

import BettingTipsPopupFooter from "./components/popups/BettingTipsPopupFooter";
import BettingTipsPopupBody from "./components/popups/BettingTipsPopupBody";
import BettingTipsStore from "@state/quick-play-store/BettingTipsStore";

export default observer(function BettingTipsPopup(props: {
	bettingTipsStore: BettingTipsStore;
	isEventLinkDisabled?: boolean;
}) {
	const popupElement = useRef<null | HTMLDivElement>(null);

	useFixBody(true, props.bettingTipsStore.isPopupDisplayed);

	useEffect(() => {
		popupElement.current?.scrollTo({ top: 0 });
	}, [props.bettingTipsStore.isPopupDisplayed]);

	if (!props.bettingTipsStore.selectedTip) {
		return null;
	}

	return (
		<div className="popup popup--qp popup--bbp">
			<div className="popup__card popup__card--grow popup--play__card">
				<BettingTipsPopupHeader store={props.bettingTipsStore} />
				<div
					className="popup__body popup--qp__body popup--bbp__body"
					ref={popupElement}
				>
					<BettingTipsPopupBody
						key={props.bettingTipsStore.selectedTip?.id}
						tip={props.bettingTipsStore.selectedTip}
						isEventLinkDisabled={props.isEventLinkDisabled}
					/>
				</div>
				<BettingTipsPopupFooter
					store={props.bettingTipsStore}
					tip={props.bettingTipsStore.selectedTip}
				/>
			</div>
		</div>
	);
});
